import { Validators } from '@angular/forms';

export const DateRangeValidators = [Validators.pattern(/(^[0-9]{4}|^\*|^)+$/)];
export const LexileRangeValidators = [Validators.pattern(/(^[0-9]{1,4}|^\*)+$/)];
export const PointRangeValidators = [Validators.pattern(/(^\d{1,2}\.\d{1}|^\*)+$/)];

export const DateRangeValidationMessages = {
  pattern: 'Enter a date range (1999 - 2005) or use an asterisk',
  requiresOne: 'At least one year is required',
};
export const LexileRangeValidationMessages = {
  required: 'A start and end range are required',
  pattern: 'Enter a range (200 - 450) or use an asterisk',
};
export const PointRangeValidationMessages = {
  required: 'A start and end range are required',
  pattern: 'Enter a range (2.0 - 7.5) or use an asterisk',
};
